import React, { useCallback, useState, useRef, useEffect } from 'react';
import { useHistory, Link } from "react-router-dom";
import { connect } from "react-redux";
import { Button } from 'devextreme-react/button';
import AccordionReact from 'devextreme-react/accordion';
import FormField from '../../../../dynamicFormBuilder/FormField'
import { GridLayout } from "../../../../common/GridLayout";
import { Localization } from "../../../../common/Localization";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import data from "../../../../assets/apiRoutes.json";
import Toolbar, { Item } from "devextreme-react/toolbar";
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar as GridToolbar,
    Item as GridToolbarItem,
  Export,
  Pager,
  ColumnChooser,
  ColumnChooserSearch,
  StateStoring,
  Lookup,
} from "devextreme-react/data-grid";
import { FillFilters, GetDatePartOnly, GetFormatedDateWithTime } from '../../../../common/Utils'
import GridLayoutManager from "../../../../gridLayoutCustomization/GridLayoutManager";
import '../../../../common/css/searchPage.css';

const searchpanel = [
    {
        ID: 1,
        Title: 'Search Filters'
    }
];

const List = (props) => {
    const history = useHistory();
    var accessToken = props.oidc.user.access_token;
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const formRefs = useRef({});
    const [selectedItems, setSelectedItems] = useState([]);
    const [searchPanelStatus, setSearchPanelStatus] = useState(false);
    const [isEditButtonDisabled, setIsEditButtonDisabled] = useState(true);
    const rowId = useRef(null);
    const dataGrid = useRef(null);

    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    const gridKey = "A3B5C7D9-E1F2-4A6B-8C9D-0E1F2A3B4C5D";
    const [currentLayout, setCurrentLayout] = useState("Default");
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    
    const initialFormFields = {
        Description: '',
        Status: '',
        ChargeType: '',
    };
    const [formFields, setformFields] = useState(initialFormFields);
    
    const onSelectionChanged = ({ selectedRowsData }) => {
        if (selectedRowsData && selectedRowsData.length == 1) {
            rowId.current = selectedRowsData[0].RowId;
            setIsEditButtonDisabled(false);
        }
        else {
            rowId.current = '';
            setIsEditButtonDisabled(true);
        }
    };

    const handelEditClick = () => {
        const buttonUrl = "/wm/codes/edit-dyn-eval-charge-config?id=" + rowId.current;
        history.push(buttonUrl);
    };

    const selectionChanged = useCallback(
        (e, tg) => {
            let newItems = [...selectedItems];
            e.removedItems.forEach((item) => {
                const index = newItems.indexOf(item);
                if (index >= 0) {
                    newItems.splice(index, 1);
                }
            });
            if (e.addedItems.length) {
                newItems = [...newItems, ...e.addedItems];
            }
            setSelectedItems(newItems);
            setSearchPanelStatus((prevStatus) => {
                const newStatus = !prevStatus;
                return newStatus;
            });
        },
        [selectedItems, setSelectedItems],
    );

    const handleSearch = (e) => {
        e.event.stopPropagation();
        // Reload datasource with current formFields to trigger server-side filtering
        let datasource = loadDatasource();
        const filters = FillFilters(formFields);
        datasource.filter(filters);
        setResultData(datasource);
    };
    
    const handleReset = (e) => {
        e.event.stopPropagation();
        setformFields(initialFormFields);
        // Reload datasource with reset fields
        setTimeout(() => {
            setResultData(loadDatasource());
        }, 100);
    }
    
    useEffect(() => {
        // Initialize datasource on mount
        if (!resultData) {
            setResultData(loadDatasource());
        }
    }, []);

    const loadLookupClient = useCallback((name, dataSource, valueExpr = 'id', displayExpr = 'text') => {
        if (!formRefs?.current?.[name]) return;
        const ref = formRefs.current[name];
        if (!ref?.instance) return;

        ref.instance().option('dataSource', dataSource);
        ref.instance().option('valueExpr', valueExpr);
        ref.instance().option('displayExpr', displayExpr);

        const currentValue = formFields?.[name];
        if (currentValue !== undefined) {
            ref.instance().option('value', currentValue);
        }
    }, [formRefs, formFields]);

    const handleFormLoad = useCallback(() => {
        const chargeTypeOptions = [
            { id: 'Transaction Charge', text: 'Transaction Charge' },
            { id: 'Item Charge', text: 'Item Charge' }
        ];

        // Use setTimeout to ensure formRefs are available after FormField renders
        setTimeout(() => {
            loadLookupClient("ChargeType", chargeTypeOptions);
        }, 100);
    }, [loadLookupClient]);

    // Load ChargeType dropdown when formRefs become available
    useEffect(() => {
        const chargeTypeOptions = [
            { id: 'Transaction Charge', text: 'Transaction Charge' },
            { id: 'Item Charge', text: 'Item Charge' }
        ];

        loadLookupClient("ChargeType", chargeTypeOptions);
    }, [loadLookupClient, formFields?.ChargeType]);

    const handleFieldChange = useCallback((name, value) => {
        // Handle field changes if needed
    }, []);

    const loadDatasource = () => {
        var url = "wm/DynEvalChargeConfig/GetDynEvalChargeConfigs";
        let store = createStore({
            key: 'RowId',
            loadParams: formFields,
            loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
            onBeforeSend: (method, ajaxOptions) => {
                ajaxOptions.headers = {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                };
            },
        });
        const dataSource = new DataSource({ store: store });
        return dataSource;
    }
    
    const [resultData, setResultData] = useState(null);

    // Simple search layout
    const SearchLayout = [
        {
            "groupId": 1,
            "fields": [
                {
                    "name": "Description",
                    "tableName": "",
                    "label": "Description",
                    "type": "text",
                    "required": false,
                    "visible": true,
                    "isLabelChanged": false,
                },
               
            ]
        }, {
            "groupId": 2,
            "fields": [
               
                {
                    "name": "ChargeType",
                    "tableName": "",
                    "label": "Charge Type",
                    "type": "select",
                    "required": false,
                    "visible": true,
                    "isLabelChanged": false,
                }
            ]
        },
        
    ];

    return (
        <div className="search-page-container">
            <div className="search-page-content">
                <div id="accordion" className="search-page-accordion">
                    <AccordionReact
                        dataSource={searchpanel}
                        collapsible={true}
                        multiple={false}
                        animationDuration={300}
                        selectedItems={selectedItems}
                        onSelectionChanged={e => {
                            if (e.currentTarget === e.target) {
                                selectionChanged(e, e.target);
                            }
                        }}
                        itemTitleRender={() => (
                            <Toolbar className="accordian-toolbar">
                                <Item location="before">
                                    <div className="title">
                                        <h6
                                            style={{
                                                color: window._env_.Color2
                                            }}
                                        >
                                            Enter Your Query For Manage Dynamically Evaluated Charges Configurations
                                        </h6>
                                    </div>
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={handleSearch} text="Search" type="default" />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={handleReset} text="Reset" />
                                </Item>
                            </Toolbar>
                        )}
                        itemRender={(itemProps) => (
                            <FormField
                                currrentUser={currentUser}
                                layoutId='B2C4D6E8-F1A3-5B7C-9D0E-1F2A3B4C5D6E'
                                layoutName='WMDynValChargeConfigSearchForm'
                                defaultFormSchema={SearchLayout}
                                formFields={formFields}
                                setformFields={setformFields}
                                handleFieldValueChange={handleFieldChange}
                                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                                formRefs={formRefs}
                                onFormLoad={handleFormLoad}
                                noSpacingBeforeFirstRow={true}
                            />
                        )}
                        id="accordion-container" className="accordion-height"
                    />
                </div>
                <div className="search-page-grid-container">
                    <DataGrid
                        onExporting={(e) => {
                            if (window.handleDevExtremeDataGridExport) {
                                window.handleDevExtremeDataGridExport(e);
                            }
                        }}
                        ref={dataGrid}
                        allowColumnReordering={true}
                        allowColumnResizing={true}
                        dataSource={resultData}
                        showBorders={true}
                        hoverStateEnabled={true}
                        className="search-page-grid"
                        onSelectionChanged={(e) => onSelectionChanged(e)}
                        remoteOperations={true}
                        searchEnabled={true}
                        columnAutoWidth={true}
                    >
                        <ColumnChooser
                            enabled={true}
                            title="Choose Column"
                            width={290}
                            height={290}
                            sortOrder="asc"
                        >
                            <ColumnChooserSearch
                                enabled={true}
                                editorOptions={{ placeholder: 'Search column' }} />
                        </ColumnChooser>
                        <Export enabled={true} allowExportSelectedData={true} />
                        <Selection mode="multiple" />
                        <Sorting visible={true} mode="multiple" />
                        <Paging defaultPageSize={10} />
                        <Pager
                            visible={true}
                            showPageSizeSelector={true}
                            allowedPageSizes={allowedPageSizes}
                            showNavigationButtons={true}
                        />
                        <FilterRow visible={true} />
                        <FilterPanel visible={true} />
                        <GroupPanel visible={true} />
                        <Grouping autoExpandAll={false} />
                        <StateStoring
                            enabled={true}
                            type="custom"
                            customLoad={loadState}
                            storageKey={gridKey}
                            customSave={saveState}
                        />
                        <Column dataType="string" caption='Description' dataField='Description'  />
                        <Column dataType="string" caption='Status' dataField='Status'  />
                        <Column dataType="string" caption='Charge Type' dataField='ChargeType'  />
                        <Column dataType="string" caption='Charge Description Source' dataField='ChargeDescriptionSource'  />
                        <Column dataType="string" caption='Charge Description' dataField='ChargeDescription'  />

                        <GridToolbar>
                            <GridToolbarItem location="before">
                                <Button
                                    disabled={isEditButtonDisabled}
                                    onClick={handelEditClick}
                                    type="default"
                                    text="Edit"
                                ></Button>
                            </GridToolbarItem>
                            <GridToolbarItem location="before">
                                <div>
                                    <Link to="/wm/codes/add-dyn-eval-charge-config">
                                        <Button
                                            type="default"
                                            className="gridTopButton"
                                            text="Create"
                                        ></Button>
                                    </Link>
                                </div>
                            </GridToolbarItem>
                             <GridToolbarItem location="after">
                             <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                            </GridToolbarItem>
                            <GridToolbarItem name="exportButton" />
                            <GridToolbarItem name="columnChooserButton" />
                        </GridToolbar>
                    </DataGrid>
                </div>
            </div>
        </div>
    );
};

function mapStateToProps(state) {
    return {
        oidc: state.oidc
    };
}

export default connect(mapStateToProps)(List);
